import jwt_decode from "jwt-decode";

export const decodeTokenBody = (token) => {

    return jwt_decode(token);
}

export const decodeTokenHeader = (token) => {

    return jwt_decode(token, { header: true });
}